import classNames from 'classnames';
import { IAPIStudioInfo } from '../../../model/api-modules';
interface INavItem {
  name: string;
  key: string;
  content: React.ReactNode;
  pathname: string;
}

interface IProps {
  selectedNavItem: string;
  studioInfo: IAPIStudioInfo;
  navItems: INavItem[];
  onClickNav: (key: string, pathname: string) => () => void;
}

export const BillingMenuComponent = (props: IProps) => {
  const { selectedNavItem, navItems, onClickNav } = props;

  return (
    <div className="nav-list">
      {navItems.map((item, index) => (
        <div
          className={classNames('list-item', {
            selected: item.key === selectedNavItem,
          })}
          key={index}
          onClick={onClickNav(item.key, item.pathname)}
        >
          {item.name}
        </div>
      ))}
    </div>
  );
};
